"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        label: __assign(__assign({}, theme_1.default.fonts.label1), { fontWeight: 'bold', display: 'flex', alignItems: 'center' }),
        defaultMargin: { marginBottom: 6 },
        mediumMargin: { marginBottom: 16 },
        largeMargin: { marginBottom: 24 },
        link: {
            marginLeft: 4,
        },
        disabled: {
            opacity: '0.5',
        },
        additionalInfo: {
            marginLeft: 8,
        },
    });
});
